// src/pages/Contact.jsx
import React, { useState } from "react";
import map from "../assets/map-img.png";

const Breadcrumb = ({ items, onNav }) => (
  <div className="breadcrumb bg-gray-50 py-4">
    <div className="w-full px-4">
      <div className="flex items-center space-x-2 text-sm">
        {items.map((it, i) => (
          <div key={it.id} className="flex items-center space-x-2">
            {i > 0 && <span className="text-[#A67C37]">›</span>}
            <button
              onClick={() => onNav(it.id)}
              className={`transition-colors ${i === items.length - 1 ? "text-[#A67C37] font-semibold" : "text-gray-600 hover:text-[#A67C37]"}`}
            >
              {it.label}
            </button>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default function ContactPage({ setCurrentPage }) {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Message sent successfully!");
    setFormData({ name: "", email: "", message: "" });
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  return (
    <>
      <Breadcrumb items={[{ id: "home", label: "Home" }, { id: "contact", label: "Contact" }]} onNav={setCurrentPage} />

      <div className="h-screen px-8 py-8">
        <iframe
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps?q=25%20Kings%20Cross%20Rd,%20Brampton,%20ON%20L6T%203V5,%20Canada&output=embed"
          className="block w-full h-full border-0 rounded-2xl shadow-lg"
        ></iframe>


      </div>




      <section className="contact py-16">
        <div className="w-full px-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow-lg p-8">
                <div className="mb-6">
                  <label className="block text-gray-700 font-semibold mb-2">Name</label>
                  <input type="text" name="name" value={formData.name} onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-green-700"
                    placeholder="Your Name" required />
                </div>
                <div className="mb-6">
                  <label className="block text-gray-700 font-semibold mb-2">Email</label>
                  <input type="email" name="email" value={formData.email} onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#A67C37]"
                    placeholder="Your Email" required />
                </div>
                <div className="mb-6">
                  <label className="block text-gray-700 font-semibold mb-2">Message</label>
                  <textarea name="message" value={formData.message} onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#A67C37]"
                    rows="4" placeholder="Message" required></textarea>
                </div>
                <div className="text-center">
                  <button type="submit" className="bg-[#C4A882] text-white px-8 py-4 rounded-lg hover:bg-[#A67C37] font-semibold text-lg">
                    Send Message
                  </button>
                </div>
              </form>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-9 h-fit">
              <h5 className="text-xl font-bold mb-4 text-gray-800">Get in Touch</h5>
              <p className="text-gray-600 mb-2">
                Be free to contact us if you have any question or confusion. We will contact you back as soon as possible.
              </p>

              <h5 className="text-lg font-semibold mb-2 text-gray-800">Email</h5>
              <p className="text-gray-600 mb-4">Our support team will get back to as soon as possible.</p>
              <h4 className="text-[#A67C37] mb-2"><a href="mailto:bicc@bramaleaicc.ca">bicc@bramaleaicc.ca</a></h4>

              <h5 className="text-lg font-semibold mb-2 text-gray-800">Contact</h5>
              <p className="text-gray-600 mb-4">Masjid Committee is available for you</p>
              <h4 className="text-[#A67C37] mb-2"><a href="tel:6477800667">647 780 0667</a></h4>

              <h5 className="text-lg font-semibold mb-2 text-gray-800">Address</h5>
              <p className="text-gray-600">25 Kings Cross Rd, Brampton, ON L6T 3V5, Canada</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
